var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"avatar",style:({width: _vm.size+'px', height: _vm.size+'px'})},[(_vm.id)?_c('ResourceImg',{attrs:{"id":_vm.id}}):_c('a-icon',{style:({fontSize: _vm.size/2+'px'}),attrs:{"type":"user"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }